var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "20px" } },
    [
      _c(
        "div",
        { staticClass: "flex" },
        _vm._l(_vm.nameList, function (item) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "Toggle",
              on: {
                click: function ($event) {
                  return _vm.onChangeName(item.id)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "Toggle_name",
                  class:
                    _vm.queryData.platformType === item.id
                      ? "color_4D8AFF"
                      : "",
                },
                [_vm._v(_vm._s(item.name))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.id === _vm.queryData.platformType,
                      expression: "item.id === queryData.platformType",
                    },
                  ],
                  staticClass: "fc",
                },
                [_c("div", { staticClass: "Toggle_whorl" })]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt10" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.dataList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "icon",
                  label: "海报",
                  width: "280",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview" },
                          [
                            _c("el-image", {
                              staticStyle: {
                                width: "89px",
                                height: "160px",
                                "border-radius": "8px",
                              },
                              attrs: {
                                src: scope.row.pic,
                                "preview-src-list": [scope.row.pic],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.enable ? "上线" : "下线") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c(
                            "div",
                            {
                              staticClass: "Operation_button",
                              on: {
                                click: function ($event) {
                                  return _vm.onEditor(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n              编辑\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "Operation_button ml10",
                              on: {
                                click: function ($event) {
                                  return _vm.onDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n              删除\n            ")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("PosterPopup", { ref: "PosterPopup", on: { refresh: _vm.onRefresh } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20 page_box" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryData.page.page,
              "page-sizes": [10, 20, 30, 40],
              "page-size": _vm.queryData.page.size,
              layout: "total, prev, pager, next, sizes,jumper",
              total: _vm.pagination.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }